import {
  atLeastOneUpperLowerNumberSpecialCharRegex,
  emailRegex,
  FULL_NAME_REGEX,
  NO_SPECIAL_CHAR_REGEX,
  OTHER_NAME_REGEX,
  validLinkRegex,
} from "../helper/string";
import { EMPLOYEE_STATUS } from "./global.constant";

const countryWiseStateOptions = {
  IN: [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Arunachal Pradesh", label: "Arunachal Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar", label: "Bihar" },
    { value: "Chhattisgarh", label: "Chhattisgarh" },
    { value: "Delhi", label: "Delhi" },
    { value: "Goa", label: "Goa" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jammu and Kashmir", label: "Jammu and Kashmir" },
    { value: "Jharkhand", label: "Jharkhand" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Madhya Pradesh", label: "Madhya Pradesh" },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Manipur", label: "Manipur" },
    { value: "Meghalaya", label: "Meghalaya" },
    { value: "Mizoram", label: "Mizoram" },
    { value: "Nagaland", label: "Nagaland" },
    { value: "Odisha", label: "Odisha" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Sikkim", label: "Sikkim" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "Telangana", label: "Telangana" },
    { value: "Tripura", label: "Tripura" },
    { value: "Uttar Pradesh", label: "Uttar Pradesh" },
    { value: "Uttarakhand", label: "Uttarakhand" },
    { value: "West Bengal", label: "West Bengal" },
  ],
  US: [
    { value: "Alabama", label: "Alabama" },
    { value: "Alaska", label: "Alaska" },
    { value: "Arizona", label: "Arizona" },
    { value: "Arkansas", label: "Arkansas" },
    { value: "California", label: "California" },
    { value: "Colorado", label: "Colorado" },
    { value: "Connecticut", label: "Connecticut" },
    { value: "Delaware", label: "Delaware" },
    { value: "Florida", label: "Florida" },
    { value: "Georgia", label: "Georgia" },
    { value: "Hawaii", label: "Hawaii" },
    { value: "Idaho", label: "Idaho" },
    { value: "Illinois", label: "Illinois" },
    { value: "Indiana", label: "Indiana" },
    { value: "Iowa", label: "Iowa" },
    { value: "Kansas", label: "Kansas" },
    { value: "Kentucky", label: "Kentucky" },
    { value: "Louisiana", label: "Louisiana" },
    { value: "Maine", label: "Maine" },
    { value: "Maryland", label: "Maryland" },
    { value: "Massachusetts", label: "Massachusetts" },
    { value: "Michigan", label: "Michigan" },
    { value: "Minnesota", label: "Minnesota" },
    { value: "Mississippi", label: "Mississippi" },
    { value: "Missouri", label: "Missouri" },
    { value: "Montana", label: "Montana" },
    { value: "Nebraska", label: "Nebraska" },
    { value: "Nevada", label: "Nevada" },
    { value: "New Hampshire", label: "New Hampshire" },
    { value: "New Jersey", label: "New Jersey" },
    { value: "New Mexico", label: "New Mexico" },
    { value: "New York", label: "New York" },
    { value: "North Carolina", label: "North Carolina" },
    { value: "North Dakota", label: "North Dakota" },
    { value: "Ohio", label: "Ohio" },
    { value: "Oklahoma", label: "Oklahoma" },
    { value: "Oregon", label: "Oregon" },
    { value: "Pennsylvania", label: "Pennsylvania" },
    { value: "Rhode Island", label: "Rhode Island" },
    { value: "South Carolina", label: "South Carolina" },
    { value: "South Dakota", label: "South Dakota" },
    { value: "Tennessee", label: "Tennessee" },
    { value: "Texas", label: "Texas" },
    { value: "Utah", label: "Utah" },
    { value: "Vermont", label: "Vermont" },
    { value: "Virginia", label: "Virginia" },
    { value: "Washington", label: "Washington" },
    { value: "West Virginia", label: "West Virginia" },
    { value: "Wisconsin", label: "Wisconsin" },
    { value: "Wyoming", label: "Wyoming" },
  ],
};
const orgTypeOptions = [
  { value: "Finance", label: "Finance" },
  { value: "Retail", label: "Retail" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "SaaS", label: "SaaS" },
  { value: "Telecommunication", label: "Telecommunication" },
  { value: "Transportation and Logistics", label: "Transportation and Logistics" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Construction", label: "Construction" },
  { value: "Professional Services", label: "Professional Services" },
  { value: "Others", label: "Others" },
];

export const SignInFormConfig = {
  formName: "Login to Lystproof",
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Email",
          field: "email",
          validation: {
            required: true,
            minLength: 1,
            maxLength: 50,
            pattern: {
              value: emailRegex,
              message: "Enter a valid email address.",
            },
          },
        },
        {
          widgetType: "password",
          label: "Password",
          field: "password",
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Invalid password format",
            },
          },
        },
      ],
    },
  ],
};

export const SignUpFormConfig = {
  IDV: {
    formName: "Sign up with Lystproof",
    showLabel: true,
    sections: [
      {
        widgets: [
          {
            widgetType: "text",
            label: "Full name",
            field: "fullName",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 35,
              pattern: {
                value: FULL_NAME_REGEX,
                message: "Enter a valid full name.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Email",
            field: "email",
            labelInfo: {
              title: "We recommend to use your personal email ID for sign-up.",
            },
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: emailRegex,
                message: "Enter a valid email address.",
              },
            },
          },
          {
            widgetType: "phone",
            label: "Phone",
            field: "phNo",
            placeholder: "Phone number",
            validation: {
              required: true,
            },
            defaultCountry: {
              cid: "99",
              iso_name: "IN",
              name: "INDIA",
              nicename: "India",
              country_name_code: "IND",
              country_num_code: "356",
              country_phone_code: "+91",
              is_active: "1",
              sms_gateway: 1,
            },
          },
          {
            widgetType: "password",
            label: "Password",
            field: "password",
            labelInfo: {
              title: "Your password must contain",
              list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
            },
            validation: {
              required: true,
              pattern: {
                value: atLeastOneUpperLowerNumberSpecialCharRegex,
                message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
              },
            },
          },
          {
            widgetType: "password",
            label: "Confirm password",
            field: "confirmPassword",
            validation: {
              required: true,
              equalityCheckField: "password",
            },
          },
          {
            widgetType: "checkbox",
            label: "I agree to the Terms & Conditions",
            field: "agreeTerms",
            hideLabel: true,
            options: [
              {
                value: "I agree to the",
                link: {
                  text: "Terms & Conditions",
                  value: "https://www.lystproof.com/terms-conditions",
                },
              },
            ],
            validation: {
              required: true,
            },
          },
        ],
      },
    ],
  },
  VFR: {
    formName: "Sign up with Lystproof",
    showLabel: true,
    sections: [
      {
        widgets: [
          {
            widgetType: "text",
            label: "Organization name",
            field: "orgName",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: OTHER_NAME_REGEX,
                message: "Enter a valid organization name.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Full name",
            field: "fullName",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 35,
              pattern: {
                value: FULL_NAME_REGEX,
                message: "Enter a valid full name.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Title",
            field: "title",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: OTHER_NAME_REGEX,
                message: "Enter a valid title.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Business email",
            field: "businessEmail",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: emailRegex,
                message: "Enter a valid email address.",
              },
              // excludeDomains: publicDomain,
            },
          },
          {
            widgetType: "phone",
            label: "Phone",
            field: "phNo",
            placeholder: "Phone number",
            validation: {
              required: true,
            },
            defaultCountry: {
              cid: "99",
              iso_name: "IN",
              name: "INDIA",
              nicename: "India",
              country_name_code: "IND",
              country_num_code: "356",
              country_phone_code: "+91",
              is_active: "1",
              sms_gateway: 1,
            },
          },
          {
            widgetType: "password",
            label: "Password",
            field: "password",
            labelInfo: {
              title: "Your password must contain",
              list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
            },
            validation: {
              required: true,
              pattern: {
                value: atLeastOneUpperLowerNumberSpecialCharRegex,
                message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
              },
            },
          },
          {
            widgetType: "password",
            label: "Confirm password",
            field: "confirmPassword",
            validation: {
              required: true,
              equalityCheckField: "password",
            },
          },
          {
            widgetType: "checkbox",
            label: "I agree to the Terms & Conditions",
            field: "agreeTerms",
            hideLabel: true,
            options: [
              {
                value: "I agree to the",
                link: {
                  text: "Terms & Conditions",
                  value: "https://www.lystproof.com/terms-conditions",
                },
              },
            ],
            validation: {
              required: true,
            },
          },
        ],
      },
    ],
  },
  ORG: {
    formName: "Sign up with Lystproof",
    showLabel: true,
    sections: [
      {
        widgets: [
          {
            widgetType: "text",
            label: "Organization name",
            field: "orgName",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: OTHER_NAME_REGEX,
                message: "Enter a valid organization name.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Full name",
            field: "fullName",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 35,
              pattern: {
                value: FULL_NAME_REGEX,
                message: "Enter a valid full name.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Title",
            field: "title",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: OTHER_NAME_REGEX,
                message: "Enter a valid title.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Business email",
            field: "businessEmail",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
              pattern: {
                value: emailRegex,
                message: "Enter a valid email address.",
              },
              // excludeDomains: publicDomain,
            },
          },
          {
            widgetType: "phone",
            label: "Phone",
            field: "phNo",
            placeholder: "Phone number",
            validation: {
              required: true,
            },
            defaultCountry: {
              cid: "99",
              iso_name: "IN",
              name: "INDIA",
              nicename: "India",
              country_name_code: "IND",
              country_num_code: "356",
              country_phone_code: "+91",
              is_active: "1",
              sms_gateway: 1,
            },
          },
          {
            widgetType: "password",
            label: "Password",
            field: "password",
            labelInfo: {
              title: "Your password must contain",
              list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
            },
            validation: {
              required: true,
              pattern: {
                value: atLeastOneUpperLowerNumberSpecialCharRegex,
                message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
              },
            },
          },
          {
            widgetType: "password",
            label: "Confirm password",
            field: "confirmPassword",
            validation: {
              required: true,
              equalityCheckField: "password",
            },
          },
          {
            widgetType: "checkbox",
            label: "I agree to the Terms & Conditions",
            field: "agreeTerms",
            hideLabel: true,
            options: [
              {
                value: "I agree to the",
                link: {
                  text: "Terms & Conditions",
                  value: "https://www.lystproof.com/terms-conditions",
                },
              },
            ],
            validation: {
              required: true,
              requiredMessage: "Please accept the Terms & Conditions.",
            },
          },
        ],
      },
    ],
  },
};

export const ResetPasswordConfig = {
  formName: "Set new password",
  submitBtnText: "Reset",
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "password",
          label: "Password",
          field: "password",
          labelInfo: {
            title: "Your password must contain",
            list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
          },
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
            },
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "password",
          label: "Confirm password",
          field: "confirmPassword",
          validation: {
            required: true,
            equalityCheckField: "password",
          },
        },
      ],
    },
  ],
};

export const ChangePasswordConfig = {
  submitBtnText: "Confirm",
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "password",
          label: "Current password",
          field: "oldPassword",
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Invalid password format",
            },
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "password",
          label: "New password",
          field: "newPassword",
          labelInfo: {
            title: "Your password must contain",
            list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
          },
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
            },
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "password",
          label: "Confirm password",
          field: "confirmPassword",
          validation: {
            required: true,
            equalityCheckField: "newPassword",
          },
        },
      ],
    },
  ],
};
export const UpdatePasswordConfig = {
  submitBtnText: "Confirm",
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "password",
          label: "New password",
          field: "newPassword",
          labelInfo: {
            title: "Your password must contain",
            list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
          },
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
            },
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "password",
          label: "Confirm password",
          field: "confirmPassword",
          validation: {
            required: true,
            equalityCheckField: "newPassword",
          },
        },
      ],
    },
  ],
};
export const AddPasswordConfig = {
  submitBtnText: "Confirm",
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "password",
          label: "New password",
          field: "newPassword",
          labelInfo: {
            title: "Your password must contain",
            list: ["8 - 64 characters length", "1 uppercase", "1 lowercase", "1 number", "1 special character"],
          },
          validation: {
            required: true,
            pattern: {
              value: atLeastOneUpperLowerNumberSpecialCharRegex,
              message: "Your password should contain 8-64 characters with a combination of uppercase, lowercase, special character and number.",
            },
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "password",
          label: "Confirm new password",
          field: "confirmPassword",
          validation: {
            required: true,
            equalityCheckField: "newPassword",
          },
        },
      ],
    },
  ],
};

export const ProfileFormConfig = {
  ORG: {
    showLabel: true,
    sections: [
      {
        widgets: [
          {
            widgetType: "text",
            label: "Organization ID",
            field: "orgId",
            apiField: "ext_org_id",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
            },
            isDisabled: true,
          },
          {
            widgetType: "text",
            label: "Organization name",
            field: "orgName",
            apiField: "org_name",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
            },
          },
          {
            widgetType: "text",
            label: "Email",
            field: "email",
            apiField: "email",
            validation: {
              required: true,
              pattern: {
                value: emailRegex,
                message: "Enter a valid email address.",
              },
            },
            isDisabled: true,
          },
          {
            widgetType: "phone",
            label: "Phone number",
            field: "phNo",
            apiField: "phone",
            viewField: "phone.phone",
            placeholder: "Phone number",
            validation: {
              required: true,
            },
            defaultCountry: {
              cid: "99",
              iso_name: "IN",
              name: "INDIA",
              nicename: "India",
              country_name_code: "IND",
              country_num_code: "356",
              country_phone_code: "+91",
              is_active: "1",
              sms_gateway: 1,
            },
            // isDisabled: true,
          },
          {
            widgetType: "select",
            label: "Organization type",
            field: "orgType",
            apiField: "org_type",
            showSearch: true,
            isAddOtherEnabled: true,
            validation: {
              required: true,
            },
            options: orgTypeOptions,
          },
          {
            widgetType: "text",
            label: "Others (Please specify)",
            field: "otherOrgType",
            apiField: "org_others",
            dependentField: "orgType",
            dependentFieldValue: "Others",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
            },
            hideOnViewMode: true,
          },
          {
            widgetType: "address",
            label: "Address",
            field: "address",
            rows: 2,
            validation: {
              required: true,
              maxLength: 200,
            },
            apiField: "line_address",
          },

          {
            widgetType: "select-country",
            label: "Country",
            field: "country",
            validation: {
              required: true,
            },
            apiField: "country",
            hideOnViewMode: true,
          },
          {
            widgetType: "select-state",
            label: "State/Province",
            field: "state",
            dependentFieldName: "country",
            showSearch: true,
            validation: {
              required: true,
            },
            messageOnNoOption: "Not applicable for selected country",
            apiField: "state_province",
            hideOnViewMode: true,
          },
          {
            widgetType: "select-city",
            label: "City",
            field: "city",
            apiField: "city",
            countryFieldName: "country",
            stateFieldName: "state",
            showSearch: true,
            validation: {
              required: true,
            },
            hideOnViewMode: true,
          },
          {
            widgetType: "number",
            label: "Zip code",
            field: "zipCode",
            hideOnViewMode: true,
            validation: {
              required: true,
              allowDecimals: false,
              maxLength: 6,
              minLength: 6,
              allowNegative: false,
            },
            apiField: "zip_code",
          },
        ],
      },
    ],
  },
  VFR: {
    showLabel: true,
    sections: [
      {
        widgets: [
          {
            widgetType: "text",
            label: "Verifier ID",
            field: "vfrId",
            apiField: "ext_org_id",
            isDisabled: true,
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
            },
          },
          {
            widgetType: "text",
            label: "Organization name",
            field: "orgName",
            apiField: "org_name",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
            },
          },
          {
            widgetType: "text",
            label: "Email",
            field: "email",
            apiField: "email",
            validation: {
              required: true,
              pattern: {
                value: emailRegex,
                message: "Enter a valid email address.",
              },
            },
            isDisabled: true,
          },
          {
            widgetType: "phone",
            label: "Phone number",
            field: "phNo",
            placeholder: "Phone number",
            apiField: "phone",
            viewField: "phone.phone",
            validation: {
              required: true,
            },
            defaultCountry: {
              cid: "99",
              iso_name: "IN",
              name: "INDIA",
              nicename: "India",
              country_name_code: "IND",
              country_num_code: "356",
              country_phone_code: "+91",
              is_active: "1",
              sms_gateway: 1,
            },
            isDisabled: true,
          },
          {
            widgetType: "address",
            label: "Address",
            field: "address",
            rows: 2,
            validation: {
              required: true,
              maxLength: 200,
            },
            apiField: "line_address",
          },
          {
            widgetType: "select",
            label: "Organization type",
            field: "orgType",
            validation: {
              required: true,
            },
            showSearch: true,
            isAddOtherEnabled: true,
            options: orgTypeOptions,
            apiField: "org_typ",
          },
          {
            widgetType: "select-country",
            label: "Country",
            field: "country",
            apiField: "country",
            validation: {
              required: true,
            },
            hideOnViewMode: true,
          },
          {
            widgetType: "dependent-select",
            label: "State/Province",
            showSearch: true,
            field: "state",
            apiField: "state_province",
            optionKeyField: "country",
            options: countryWiseStateOptions,
            validation: {
              required: true,
            },
            messageOnNoOption: "Not applicable for selected country",
            hideOnViewMode: true,
          },
          {
            widgetType: "text",
            label: "City",
            field: "city",
            apiField: "city",
            hideOnViewMode: true,
            validation: {
              required: true,
            },
          },
          {
            widgetType: "number",
            label: "Zip code",
            field: "zipCode",
            validation: {
              required: true,
              allowDecimals: false,
              maxLength: 6,
              minLength: 6,
              allowNegative: false,
            },
            hideOnViewMode: true,
            apiField: "zip_code",
          },
        ],
      },
    ],
  },
  // There will be No Profile
  IDV: {
    showLabel: true,
    sections: [
      {
        widgets: [
          {
            widgetType: "text",
            label: "User ID",
            field: "userId",
            apiField: "ext_user_id",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 50,
            },
            isDisabled: true,
          },
          {
            widgetType: "text",
            label: "Full Name",
            field: "fullName",
            apiField: "name",
            validation: {
              required: true,
              minLength: 1,
              maxLength: 35,
              pattern: {
                value: FULL_NAME_REGEX,
                message: "Enter a valid full name.",
              },
            },
          },
          {
            widgetType: "text",
            label: "Email",
            field: "email",
            apiField: "email",
            validation: {
              required: true,
              pattern: {
                value: emailRegex,
                message: "Enter a valid email address.",
              },
            },
            isDisabled: true,
          },
          {
            widgetType: "phone",
            label: "Phone",
            field: "phNo",
            apiField: "phone",
            viewField: "phone.phone",
            placeholder: "Phone number",
            validation: {
              required: true,
            },
            defaultCountry: {
              cid: "99",
              iso_name: "IN",
              name: "INDIA",
              nicename: "India",
              country_name_code: "IND",
              country_num_code: "356",
              country_phone_code: "+91",
              is_active: "1",
              sms_gateway: 1,
            },
            isDisabled: true,
          },
          {
            widgetType: "date",
            field: "dob",
            label: "DOB",
            apiField: "dob",
            placeholder: "Select DOB",
            validation: {
              required: true,
              minDate: "1960-01-01",
              maxToday: true,
            },
          },
          {
            widgetType: "textarea",
            label: "Address",
            field: "address",
            apiField: "address",
            rows: 2,
            validation: {
              required: true,
              maxLength: 200,
            },
          },
          {
            widgetType: "select-country",
            label: "Country",
            field: "country",
            apiField: "user_info.country",
            validation: {
              required: true,
            },
            hideOnViewMode: true,
          },
          {
            widgetType: "dependent-select",
            label: "State/Province",
            showSearch: true,
            field: "state",
            apiField: "user_info.state",
            optionKeyField: "country",
            options: countryWiseStateOptions,
            validation: {
              required: true,
            },
            hideOnViewMode: true,
            messageOnNoOption: "Not applicable for selected country",
          },
          {
            widgetType: "text",
            label: "City",
            field: "city",
            validation: {
              required: true,
            },
            apiField: "user_info.city",
            hideOnViewMode: true,
          },
          {
            widgetType: "number",
            label: "Zip code",
            field: "zipCode",
            apiField: "user_info.zipCode",
            validation: {
              required: true,
              allowDecimals: false,
              maxLength: 6,
              minLength: 6,
              allowNegative: false,
            },
            hideOnViewMode: true,
          },
        ],
      },
    ],
  },
};
export const MyProfileConfig = {
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "User ID",
          field: "userId",
          apiField: "ext_user_id",
          validation: {
            required: true,
            minLength: 1,
            maxLength: 50,
          },
          isDisabled: true,
        },
        {
          widgetType: "text",
          label: "Full Name",
          field: "fullName",
          apiField: "fullName",
          validation: {
            required: true,
            minLength: 1,
            maxLength: 35,
          },
        },
        {
          widgetType: "text",
          label: "Email",
          field: "email",
          apiField: "email",
          validation: {
            required: true,
            pattern: {
              value: emailRegex,
              message: "Enter a valid email address.",
            },
          },
          isDisabled: true,
        },
        {
          widgetType: "phone",
          label: "Phone number",
          field: "phNo",
          apiField: "phone",
          viewField: "phone.phone",
          placeholder: "Phone number",
          validation: {
            required: true,
          },
          defaultCountry: {
            cid: "99",
            iso_name: "IN",
            name: "INDIA",
            nicename: "India",
            country_name_code: "IND",
            country_num_code: "356",
            country_phone_code: "+91",
            is_active: "1",
            sms_gateway: 1,
          },
          isDisabled: true,
          infoText: "Edit phone number in security section",
        },
        {
          widgetType: "date",
          field: "dob",
          label: "DOB",
          apiField: "dob",
          placeholder: "Select DOB",
          validation: {
            required: true,
            minDate: "1960-01-01",
            maxToday: true,
          },
        },
      ],
    },
  ],
};
export const AddressFormConfig = {
  showLabel: true,
  submitBtnText: "Save",
  cancelBtnText: "Close",
  widgetsClass: "basis-[100%] md:basis-[calc(50%-20px)]",
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Line address",
          field: "lineAddress",
          validation: {
            required: true,
            minLength: 5,
            maxLength: 200,
          },
        },
        {
          widgetType: "select-country",
          label: "Country",
          field: "country",
          validation: {
            required: true,
          },
          showSearch: true,
        },
        {
          widgetType: "select-state",
          label: "State/Province",
          field: "state",
          dependentFieldName: "country",
          showSearch: true,
          validation: {
            required: true,
          },
          messageOnNoOption: "Not applicable for selected country",
        },
        {
          widgetType: "select-city",
          label: "City",
          field: "city",
          countryFieldName: "country",
          stateFieldName: "state",
          showSearch: true,
          validation: {
            required: true,
          },
          hideOnViewMode: true,
        },
        {
          widgetType: "number",
          label: "Zip code",
          field: "zipCode",
          validation: {
            required: true,
          },
        },
        {
          widgetType: "text",
          label: "Latitude",
          field: "latitude",
        },
        {
          widgetType: "text",
          label: "Longitude",
          field: "longitude",
        },
      ],
    },
  ],
};

export const LetterHeadFormConfig = {
  showLabel: true,
  sections: [
    {
      widgets: [
        {
          widgetType: "select",
          label: "Choose template",
          field: "templateId",
          apiField: "letter_head_template_id",
          // showSearch: true,
          isAddOtherEnabled: true,
          validation: {
            required: true,
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "text",
          label: "Company Name",
          field: "cmpName",
          apiField: "cmp_name",
          validation: {
            required: true,
            maxLength: 100,
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "phone",
          label: "Phone",
          field: "phNo",
          apiField: "letter_head.phone",
          placeholder: "Phone number",
          validation: {
            required: true,
          },
          defaultCountry: {
            cid: "99",
            iso_name: "IN",
            name: "INDIA",
            nicename: "India",
            country_name_code: "IND",
            country_num_code: "356",
            country_phone_code: "+91",
            is_active: "1",
            sms_gateway: 1,
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "text",
          label: "Email",
          field: "email",
          apiField: "letter_head.email",
          validation: {
            required: true,
            minLength: 1,
            maxLength: 50,
            pattern: {
              value: emailRegex,
              message: "Enter a valid email address.",
            },
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "textarea",
          label: "Address",
          field: "address",
          apiField: "letter_head.address",
          rows: 2,
          validation: {
            required: true,
            maxLength: 200,
          },
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "select-from-api",
          label: "Select signatory",
          field: "signatory",
          apiField: "letter_head.signatory",
          validation: {
            required: true,
          },
          optionsApiUrl: "/employee/option?option_key=signatory",
          // showSearch: true,
          isObjectAsValue: true,
        },
      ],
    },
    {
      widgets: [
        {
          widgetType: "upload-single-file",
          label: "Logo",
          field: "logo",
          apiField: "letter_head.logo",
          uploadKey: "letter-head",
          showSearch: true,
          isAddOtherEnabled: true,
          message: {
            success: "Your logo has been attached successfully!",
            error: "There was an error attaching  the logo, please try again!",
          },
          validation: {
            required: true,
            allowedFileType: "image",
          },
          isFreeCrop: true,
        },
      ],
    },
  ],
};

// Add Documents Modal
export const DocumentFormSections = {
  PAN: {
    widgets: [
      {
        widgetType: "text",
        label: "PAN number",
        field: "PAN-Number",
        apiField: "documentNumber",
        validation: {
          required: true,
          maxLength: 10,
          minLength: 10,
          pattern: {
            value: /^[A-Z]{3}[ABCFGHLJPT][A-Z][0-9]{4}[A-Z]$/,
            message: "Enter a valid Pan number",
          },
        },
      },
      {
        widgetType: "upload-document-file",
        label: "",
        field: "PAN",
        hideLabel: true,
        uploadKey: "documents",
        apiField: "base",
        validation: {
          required: true,
          allowedFileType: "image-and-pdf",
        },
      },
    ],
  },
  Aadhar: {
    widgets: [
      {
        widgetType: "number",
        label: "Aadhar number",
        field: "Aadhar-Number",
        apiField: "documentNumber",
        validation: {
          required: true,
          maxLength: 12,
          minLength: 12,
          pattern: {
            value: /^[0-9]{12}$/,
            message: "Enter a valid Aadhar number",
          },
        },
      },
      {
        widgetType: "upload-document-file",
        label: "",
        field: "Aadhar",
        apiField: "base",
        hideLabel: true,
        uploadKey: "documents",
        validation: {
          required: true,
          allowedFileType: "image-and-pdf",
        },
      },
    ],
  },
  CIN: {
    widgets: [
      {
        widgetType: "text",
        label: "CIN number",
        field: "CIN-Number",
        apiField: "documentNumber",
        validation: {
          required: true,
          maxLength: 21,
          minLength: 21,
          pattern: {
            value: /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
            message: "Enter a valid CIN number",
          },
        },
      },
      {
        widgetType: "upload-document-file",
        label: "",
        field: "CIN",
        hideLabel: true,
        uploadKey: "documents",
        apiField: "base",
        validation: {
          required: true,
          allowedFileType: "image-and-pdf",
        },
      },
    ],
  },
  EIN: {
    widgets: [
      {
        widgetType: "text",
        label: "EIN number",
        field: "EIN-Number",
        apiField: "documentNumber",
        validation: {
          required: true,
          maxLength: 10,
          minLength: 10,
          pattern: {
            value: /^\d{2}-\d{7}$/,
            message: "Enter a valid EIN number (XX-XXXXXXX)",
          },
        },
      },
      {
        widgetType: "upload-document-file",
        label: "",
        field: "EIN",
        hideLabel: true,
        uploadKey: "documents",
        apiField: "base",
        validation: {
          required: true,
          allowedFileType: "image-and-pdf",
        },
      },
    ],
  },
  GST: {
    widgets: [
      {
        widgetType: "text",
        label: "GST number",
        field: "GST-Number",
        apiField: "documentNumber",
        validation: {
          required: true,
          maxLength: 15,
          pattern: {
            value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            message: "Enter a valid GST number",
          },
        },
      },
      {
        widgetType: "upload-document-file",
        label: "",
        field: "GST",
        hideLabel: true,
        uploadKey: "documents",
        apiField: "base",
        validation: {
          required: true,
          allowedFileType: "image-and-pdf",
        },
      },
    ],
  },
};

export const AddEmployeeConfig = {
  showLabel: true,
  formKey: "add",
  submitBtnText: "Add",
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Employee ID",
          field: "empId",
          validation: {
            required: true,
            maxLength: 15,
            pattern: {
              value: NO_SPECIAL_CHAR_REGEX,
              message: "special character not allowed.",
            },
          },
        },
        {
          widgetType: "text",
          label: "Employee name",
          field: "fullName",
          viewType: "profile",
          apiField: "empName",
          validation: {
            required: true,
            pattern: {
              value: FULL_NAME_REGEX,
              message: "Enter a valid employee name.",
            },
          },
        },
        {
          widgetType: "text",
          label: "Email",
          field: "empEmail",
          apiField: "empEml",
          validation: {
            required: true,
            pattern: {
              value: emailRegex,
              message: "Enter a valid email address.",
            },
          },
        },
        {
          widgetType: "phone",
          label: "Phone number",
          field: "phoneNumber",
          placeholder: "Phone number",
          validation: {
            required: true,
          },
          apiField: "phone",
          newFill: true,
          defaultCountry: {
            cid: "99",
            iso_name: "IN",
            name: "INDIA",
            nicename: "India",
            country_name_code: "IND",
            country_num_code: "356",
            country_phone_code: "+91",
            is_active: "1",
            sms_gateway: 1,
          },
        },
        {
          widgetType: "select-from-api",
          label: "User type",
          field: "userType",
          apiField: "userTyp",
          validation: {
            required: true,
          },
          hideOnViewMode: true,
          formValueKey: "value",
          optionsApiUrl: "/employee/option?option_key=org-roles",
        },
        {
          widgetType: "select-from-api",
          label: "Designation",
          field: "designation",
          apiField: "designation",
          validation: {
            required: true,
          },
          showSearch: true,
          optionsApiUrl: "/employee/option?option_key=designatn",
          addNewOptions: { api: "/employee/option", optionKey: "designatn" },
          updateOptions: { api: "/employee/update-option", optionKey: "designatn" },
        },
        {
          widgetType: "date",
          field: "doj",
          label: "Date of joining",
          apiField: "strtDt",
          placeholder: "",
          validation: {
            required: true,
            minDate: "1960-01-01",
            maxToday: true,
          },
        },
        {
          widgetType: "number-with-currency",
          label: "CTC",
          field: "ctc",
          viewField: "ctc.view",
          validation: { required: true },
          readOnly: true,
          defaultCountry: 99,
          hideOnViewMode: true,
          defaultValue: {
            currencyId: 99,
          },
        },
        {
          widgetType: "select-from-api",
          label: "Employment type",
          field: "empType",
          apiField: "empTyp",
          validation: {
            required: true,
          },
          hideOnViewMode: true,
          optionsApiUrl: "/employee/option?option_key=employment_typ",
          addNewOptions: { api: "/employee/option", optionKey: "employment_typ" },
          showSearch: true,
        },
        {
          widgetType: "select-from-api",
          label: "Employment status",
          field: "status",
          validation: {
            required: true,
          },
          optionsApiUrl: "/employee/option?option_key=emp-sts&filter=active",
        },
        {
          widgetType: "select-from-api",
          viewType: "profile",
          label: "Reporting manager",
          field: "reportingManager",
          validation: {
            required: true,
          },
          isAddEmpIDFilter: true,
          apiField: "reportingMngr",
          optionsApiUrl: "/employee/option?option_key=employees&filter=active",
          showSearch: true,
        },
        {
          widgetType: "textarea",
          label: "Address",
          field: "address",
          rows: 2,
          validation: {
            required: false,
            maxLength: 200,
          },
          apiField: "address",
        },
        {
          widgetType: "select-from-api",
          label: "Department",
          field: "department",
          apiField: "depart",
          validation: {
            required: true,
          },
          showSearch: true,
          optionsApiUrl: "/employee/option?option_key=depart",
          addNewOptions: { api: "/employee/option", optionKey: "depart" },
          updateOptions: { api: "/employee/update-option", optionKey: "depart" },
        },
        {
          widgetType: "text",
          label: "PAN number",
          field: "panNumber",
          apiField: "panNo",
          validation: {
            required: false,
            pattern: {
              value: /^[A-Z]{5}\d{4}[A-Z]$/,
              message: "Invalid PAN number format",
            },
          },
        },
        {
          widgetType: "text",
          label: "Aadhar number",
          field: "aadharNumber",
          apiField: "aadharNo",
          validation: {
            required: false,
            pattern: {
              value: /^\d{12}$/,
              message: "Aadhar number must be 12 digits",
            },
          },
        },
        {
          widgetType: "social",
          label: "Social information",
          hideOnViewMode: true,
          field: "social",
          apiField: "social",
          fields: [
            { id: "linkedin", label: "LinkedIn" },
            { id: "twitter", label: "X" },
            { id: "facebook", label: "Facebook" },
            { id: "instagram", label: "Instagram" },
          ],
          validation: {
            required: false,
            pattern: {
              value: validLinkRegex,
              message: "Enter a valid URL.",
            },
          },
        },
      ],
    },
  ],
};
export const EditEmployeeConfig = {
  showLabel: true,
  formKey: "edit-employee",
  submitBtnText: "Update",
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Employee ID",
          field: "empId",
          validation: {
            required: true,
            maxLength: 15,
            pattern: {
              value: NO_SPECIAL_CHAR_REGEX,
              message: "special character not allowed.",
            },
          },
        },
        {
          widgetType: "text",
          label: "Employee name",
          field: "fullName",
          apiField: "empName.label",
          validation: {
            required: true,
            pattern: {
              value: FULL_NAME_REGEX,
              message: "Enter a valid employee name.",
            },
          },
        },
        {
          widgetType: "text",
          label: "Email",
          field: "empEmail",
          apiField: "empEml",
          validation: {
            required: true,
            pattern: {
              value: emailRegex,
              message: "Enter a valid email address.",
            },
          },
        },
        {
          widgetType: "phone",
          label: "Phone number",
          field: "phoneNumber",
          validation: {
            required: true,
          },
          apiField: "phone",
          newFill: true,
          defaultValue: {
            country_phone_code: "91",
            cid: 99,
          },
        },
        {
          widgetType: "select-from-api",
          label: "User type",
          field: "userType",
          apiField: "userTyp",
          validation: {
            required: true,
          },
          hideOnViewMode: true,
          formValueKey: "value",
          optionsApiUrl: "/employee/option?option_key=org-roles",
        },
        {
          widgetType: "select-from-api",
          label: "Designation",
          field: "designation",
          apiField: "designation",
          validation: {
            required: true,
          },
          showSearch: true,
          optionsApiUrl: "/employee/option?option_key=designatn",
          addNewOptions: { api: "/employee/option", optionKey: "designatn" },
          updateOptions: { api: "/employee/update-option", optionKey: "designatn" },
        },
        {
          widgetType: "date",
          field: "doj",
          label: "Date of joining",
          apiField: "strtDt",
          placeholder: "",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS.ACTIVE,
          validation: {
            required: true,
            minDate: "1960-01-01",
            maxToday: true,
          },
        },
        {
          widgetType: "dateRange",
          label: "Employment period",
          field: "employmentPeriod",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          fields: [
            { label: "Start Date", field: "startDate" },
            { label: "End Date", field: "endDate" },
          ],
          restrictFutureDates: true,
          validation: { required: true },
        },
        {
          widgetType: "number-with-currency",
          label: "CTC",
          field: "ctc",
          viewField: "ctc.view",
          validation: { required: true },
          readOnly: true,
          defaultCountry: 99,
          hideOnViewMode: true,
          defaultValue: {
            currencyId: 99,
          },
        },
        {
          widgetType: "select-from-api",
          label: "Employment type",
          field: "empType",
          apiField: "empTyp",
          validation: {
            required: true,
          },
          hideOnViewMode: true,
          optionsApiUrl: "/employee/option?option_key=employment_typ",
          addNewOptions: { api: "/employee/option", optionKey: "employment_typ" },
          showSearch: true,
        },
        {
          widgetType: "select-from-api",
          label: "Employment status",
          field: "status",
          validation: {
            required: true,
          },
          optionsApiUrl: "/employee/option?option_key=emp-sts&filter=active",
        },
        {
          widgetType: "select-from-api",
          label: "Reporting manager",
          field: "reportingManager",
          isAddEmpIDFilter: true,
          validation: {
            required: true,
          },
          apiField: "reportingMngr",
          optionsApiUrl: "/employee/option?option_key=employees&filter=active",
          showSearch: true,
        },
        {
          widgetType: "textarea",
          label: "Address",
          field: "address",
          rows: 2,
          validation: {
            required: false,
            maxLength: 200,
          },
          apiField: "address",
        },
        {
          widgetType: "select-from-api",
          label: "Department",
          field: "department",
          apiField: "depart",
          validation: {
            required: true,
          },
          showSearch: true,
          optionsApiUrl: "/employee/option?option_key=depart",
          addNewOptions: { api: "/employee/option", optionKey: "depart" },
          updateOptions: { api: "/employee/update-option", optionKey: "depart" },
        },
        {
          widgetType: "text",
          label: "PAN number",
          field: "panNumber",
          apiField: "panNo",
          validation: {
            required: false,
            pattern: {
              value: /^[A-Z]{5}\d{4}[A-Z]$/,
              message: "Invalid PAN number format",
            },
          },
        },
        {
          widgetType: "text",
          label: "Aadhar number",
          field: "aadharNumber",
          apiField: "aadharNo",
          validation: {
            required: false,
            pattern: {
              value: /^\d{12}$/,
              message: "Aadhar number must be 12 digits",
            },
          },
        },
        {
          widgetType: "social",
          label: "Social information",
          hideOnViewMode: true,
          field: "social",
          apiField: "social",
          fields: [
            { id: "linkedin", label: "LinkedIn" },
            { id: "twitter", label: "X" },
            { id: "facebook", label: "Facebook" },
            { id: "instagram", label: "Instagram" },
          ],
          validation: {
            required: false,
            pattern: {
              value: validLinkRegex,
              message: "Enter a valid URL.",
            },
          },
        },
        {
          widgetType: "textarea",
          label: "Reason for leaving",
          field: "reasonForLeaving",
          apiField: "leavingReason",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          validation: { required: true, maxLength: 200 },
        },
        {
          widgetType: "radio",
          label: "Notice period served",
          field: "noticeServe",
          apiField: "noticeServed",
          validation: { required: true },
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
        },
        {
          widgetType: "textarea",
          label: "Conduct and work ethic",
          field: "conductAndEthic",
          apiField: "conductEthics",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          validation: { required: true, maxLength: 500 },
        },
        {
          widgetType: "select",
          label: "Clearance status",
          field: "clearanceStatus",
          validation: { required: true },
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          options: [
            { value: "CLEARED", label: "Cleared" },
            { value: "PENDING", label: "Pending" },
            { value: "NOT_CLEARED", label: "Not Cleared" },
          ],
        },
        {
          widgetType: "radio",
          label: "Eligible to rehire",
          field: "eligibleToRehire",
          apiField: "rehireEligibility",
          validation: { required: true },
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
        },
        {
          widgetType: "radio",
          label: "Relieving letter issued",
          field: "relivingLetter",
          apiField: "relievLetterIsud",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          validation: { required: true },
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
        },
        {
          widgetType: "number-with-currency",
          label: "Last drawn salary",
          field: "lastDrawnSalary",
          apiField: "lstDrawnSalary",
          viewField: "lstDrawnSalary.view",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          autoFillDependentFieldValue: "currencyCid",
          validation: { required: true },
          defaultValue: {
            currencyId: 99,
          },
          currencySelectDisabled: true,
        },
        {
          widgetType: "upload-document-file",
          label: "Supporting documents",
          field: "supportingDoc",
          uploadKey: "documents",
          apiField: "exitDoc",
          dependentField: "status",
          dependentFieldValue: EMPLOYEE_STATUS["Ex-employee"],
          validation: {
            required: false,
            allowedFileType: "image-and-pdf",
          },
          wigetInfo: { btnText: "Upload File", variant: "outline" },
        },
      ],
    },
  ],
};

export const ExitEmployeeConfig = {
  showLabel: true,
  formKey: "exit",
  submitBtnText: "Save",
  sections: [
    {
      widgets: [
        {
          widgetType: "text",
          label: "Employee ID",
          field: "empId",
          validation: {
            required: false,
            maxLength: 15,
            pattern: {
              value: NO_SPECIAL_CHAR_REGEX,
              message: "special character not allowed.",
            },
          },
          isDisabled: true,
          setValueOnDisabled: true,
        },
        {
          widgetType: "text",
          label: "Employee name",
          field: "empName",
          viewType: "profile",
          apiField: "empName.label",
          viewField: "empName",
          validation: {
            required: false,
            pattern: {
              value: FULL_NAME_REGEX,
              message: "Enter a valid employee name.",
            },
          },
          isDisabled: true,
        },
        {
          widgetType: "select-from-api",
          label: "Designation",
          field: "designation",
          validation: {
            required: true,
          },
          showSearch: true,
          optionsApiUrl: "/employee/option?option_key=designatn",
          addNewOptions: { api: "/employee/option", optionKey: "designatn" },
          updateOptions: { api: "/employee/update-option", optionKey: "designatn" },
        },
        {
          widgetType: "select-from-api",
          label: "Employment type",
          field: "empTyp",
          validation: {
            required: true,
          },
          optionsApiUrl: "/employee/option?option_key=employment_typ",
          addNewOptions: { api: "/employee/option", optionKey: "employment_typ" },
          readOnly: true,
        },
        {
          widgetType: "select-from-api",
          label: "Reporting manager",
          field: "reportingManager",
          viewType: "profile",
          isAddEmpIDFilter: true,
          apiField: "reportingMngr",
          validation: {
            required: true,
          },
          optionsApiUrl: "/employee/option?option_key=employees&filter=active",
          showSearch: true,
        },
        {
          widgetType: "number-with-currency",
          label: "CTC",
          field: "ctc",
          apiField: "ctc",
          viewField: "ctc.view",
          validation: { required: true },
          readOnly: true,
          defaultValue: {
            currencyId: 99,
          },
        },
        {
          widgetType: "dateRange",
          label: "Employment period",
          field: "employmentPeriod",
          fields: [
            { label: "Start Date", field: "startDate" },
            { label: "End Date", field: "endDate" },
          ],
          restrictFutureDates: true,
          validation: { required: true },
        },
        {
          widgetType: "textarea",
          label: "Reason for leaving",
          field: "reasonForLeaving",
          apiField: "leavingReason",
          validation: { required: true, maxLength: 200 },
        },
        {
          widgetType: "radio",
          label: "Notice period served",
          field: "noticeServe",
          apiField: "noticeServed",
          validation: { required: true },
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
        },
        {
          widgetType: "textarea",
          label: "Conduct and work ethic",
          field: "conductAndEthic",
          apiField: "conductEthics",
          validation: { required: true, maxLength: 500 },
        },
        {
          widgetType: "select",
          label: "Clearance status",
          field: "clearanceStatus",
          validation: { required: true },
          options: [
            { value: "CLEARED", label: "Cleared" },
            { value: "PENDING", label: "Pending" },
            { value: "NOT_CLEARED", label: "Not Cleared" },
          ],
        },
        {
          widgetType: "radio",
          label: "Eligible to rehire",
          field: "eligibleToRehire",
          apiField: "rehireEligibility",
          validation: { required: true },
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
        },
        {
          widgetType: "radio",
          label: "Relieving letter issued",
          field: "relivingLetter",
          apiField: "relievLetterIsud",
          validation: { required: true },
          options: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
        },
        {
          widgetType: "number-with-currency",
          label: "Last drawn salary",
          field: "lastDrawnSalary",
          apiField: "lstDrawnSalary",
          viewField: "lstDrawnSalary.view",
          validation: { required: true },
          autoFillDependentFieldValue: "currencyCid",
          defaultValue: {
            currencyId: 99,
          },
          currencySelectDisabled: true,
        },
        {
          widgetType: "upload-document-file",
          label: "Supporting documents",
          field: "supportingDoc",
          uploadKey: "documents",
          apiField: "exitDoc",
          validation: {
            required: false,
            allowedFileType: "image-and-pdf",
          },
          wigetInfo: { btnText: "Upload File", variant: "outline" },
        },
      ],
    },
  ],
};

export const AddSignatoryConfig = {
  showLabel: true,
  submitBtnText: "Submit",
  formKey: "add-signatory",
  sections: [
    {
      widgets: [
        {
          widgetType: "select-from-api",
          label: "Select employee",
          field: "employeeId",
          apiField: "employeeId",
          validation: {
            required: true,
          },
          optionsApiUrl: "/employee/option?option_key=employees&filter=signatory",
          showSearch: true,
        },
        {
          widgetType: "upload-single-file",
          label: "Seal & Signature",
          field: "authorizedDoc",
          uploadKey: "documents",
          apiField: "authorizedDoc",
          validation: {
            required: true,
            allowedFileType: "image-and-pdf",
          },
        },
      ],
    },
  ],
};
